import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { GraphService } from '@/services/graph.service';
import { useUserStore } from '@/store';

export const useUserProfile = () => {
  const { instance } = useMsal();
  const { user, isLoading, error, setUser, setLoading, setError } = useUserStore();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setLoading(true);
        const graphService = new GraphService(instance);
        const profile = await graphService.getProfile();
        setUser(profile);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch profile');
      } finally {
        setLoading(false);
      }
    };

    const account = instance.getActiveAccount();
    if (account && !user) {
      fetchProfile();
    } else if (!account) {
      setLoading(false);
    }
  }, [instance, user, setUser, setLoading, setError]);

  return { user, loading: isLoading, error };
};
